import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';

const PropertyContext = createContext();

export function PropertyProvider({ children }) {
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [hydrated, setHydrated] = useState(false);

  // On mount, rehydrate from localStorage
  useEffect(() => {
    const raw = localStorage.getItem('selectedProperty');
    if (raw) {
      try {
        setSelectedProperty(JSON.parse(raw));
      } catch (err) {
        console.error('Failed to parse selectedProperty:', err);
      }
    }
    setHydrated(true);
  }, []);

  // Use this to pick a property (and persist it)
  const selectProperty = (property) => {
    setSelectedProperty(property);
    try {
      localStorage.setItem('selectedProperty', JSON.stringify(property));
    } catch (err) {
      console.error('Failed to save selectedProperty:', err);
    }
  };

  return (
    <PropertyContext.Provider
      value={{ selectedProperty, selectProperty, hydrated }}
    >
      {children}
    </PropertyContext.Provider>
  );
}

export function useProperty() {
  return useContext(PropertyContext);
}
